import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
	Box,
	Button,
	Typography,
	Paper,
	Chip,
	CircularProgress,
} from "@mui/material";
import ameraucanaImg from "../../Images/March_2026_Bird_Photos/ameraucana.jpg";
import americana from "../../Images/Baby_Bird_Photos/americana.jpg";
import australorpImg from "../../Images/March_2026_Bird_Photos/australorp.jpg";
import barredRockImg from "../../Images/March_2026_Bird_Photos/barred_rock.jpg";
import andalusianImg from "../../Images/Baby_Bird_Photos/andalusian.jpeg";

import buffOrpingtonImg from "../../Images/Baby_Bird_Photos/buff_orphington.jpg";
import creamLegbarImg from "../../Images/Baby_Bird_Photos/cream_legbar.jpeg";
import brahmaImg from "../../Images/Baby_Bird_Photos/brahma.jpeg";
import midnightMajestyImg from "../../Images/Baby_Bird_Photos/midnight_majesty.jpeg";
import starlightGreenEggerImg from "../../Images/Baby_Bird_Photos/starlight_green_egger.jpeg";
import bieleferlderImg from "../../Images/Baby_Bird_Photos/bielefelder.jpeg";
import blackSexLinkImg from "../../Images/March_2026_Bird_Photos/black_sex_link.jpg";
import wyandotteImg from "../../Images/Baby_Bird_Photos/wyandotte.jpeg";
import pearlWhiteLeghornImg from "../../Images/Baby_Bird_Photos/pearl_white_leghorn.jpeg";
import redStarImg from "../../Images/Baby_Bird_Photos/red_star.jpeg";
import whitingTrueGreenImg from "../../Images/Baby_Bird_Photos/whiting_true_green.jpeg";
import sapphireGemImg from "../../Images/March_2026_Bird_Photos/sapphire_gem.jpg";

import blackSwedishImg from "../../Images/DuckPhotos/black_swedish.jpg";
import blueSwedishImg from "../../Images/DuckPhotos/blue_swedish.jpg";
import cayugaImg from "../../Images/DuckPhotos/cayuga.jpg";
import khakiCampbellImg from "../../Images/DuckPhotos/khaki_campbell.jpg";
import goldStarHybridImg from "../../Images/DuckPhotos/gold_star_hybrid.jpg";
import whiteStarHybridImg from "../../Images/DuckPhotos/white_star_hybrid.jpg";

import remiImg from "../../Images/Baby_Bird_Photos/Remi.jpeg";
import reggieImg from "../../Images/Baby_Bird_Photos/reggie.jpeg";
import randolphImg from "../../Images/Baby_Bird_Photos/randolph.jpg";

const BREEDS = [
	{
		name: "Ameraucana",
		egg: "Blue",
		desc: "Hardy, calm, and colorful egg layers.",
		img: ameraucanaImg,
	},
	{
		name: "Americana",
		egg: "Variety",
		desc: "A beautiful mix of colors and patterns.",
		img: americana,
	},
	{
		name: "Australorp",
		egg: "Brown",
		desc: "Champion layers and cold-weather tough.",
		img: australorpImg,
	},
	{
		name: "Barred Plymouth Rock",
		egg: "Brown",
		desc: "Classic farm bird with strong work ethic.",
		img: barredRockImg,
	},
	{
		name: "Bielefelder",
		egg: "Light Brown",
		desc: "Friendly, curious, and excellent layers.",
		img: bieleferlderImg,
	},
	{
		name: "Black Sex Link",
		egg: "Brown",
		desc: "Reliable layers with a calm temperament.",
		img: blackSexLinkImg,
	},
	{
		name: "Blue Andalusian",
		egg: "White",
		desc: "Elegant birds known for their striking white eggs.",
		img: andalusianImg,
	},

	{
		name: "Buff Orpington",
		egg: "Cream",
		desc: "Fluffy, friendly, and loves going broody.",
		img: buffOrpingtonImg,
	},

	{
		name: "Cream Legbar",
		egg: "Blue",
		desc: "Small bird, BIG personality, gorgeous blue eggs.",
		img: creamLegbarImg,
	},
	{
		name: "Light & Dark Brahma",
		egg: "Soft Brown",
		desc: "Gentle giants of the coop.",
		img: brahmaImg,
	},
	{
		name: "Midnight Majesty Maran",
		egg: "Dark Brown",
		desc: "Moody looks, rich chocolate eggs.",
		img: midnightMajestyImg,
	},
	{
		name: "Pearl White Leghorn",
		egg: "White",
		desc: "A prolific layer of large white eggs.",
		img: pearlWhiteLeghornImg,
	},
	{
		name: "Red Star",
		egg: "Brown",
		desc: "High egg production and friendly temperament.",
		img: redStarImg,
	},
	{
		name: "Sapphire Gem",
		egg: "Brown",
		desc: "Striking Brown eggs from a hardy and active breed.",
		img: sapphireGemImg,
	},
	{
		name: "Starlight Green Egger",
		egg: "Green",
		desc: "A carton favorite for color lovers.",
		img: starlightGreenEggerImg,
	},
	{
		name: "Whiting True Green",
		egg: "Green",
		desc: "Vigorous layers producing vibrant green eggs.",
		img: whitingTrueGreenImg,
	},
	{
		name: "Wyandotte",
		egg: "Cream",
		desc: "Both Gold and Silver varieties. Friendly, hardy birds with beautiful plumage.",
		img: wyandotteImg,
	},
];

const ROOSTERS = [
	{
		name: "Remington (Remi)",
		desc: "The 10-lb Light Brahma boss. Demanding, fair, and fiercely loyal.",
		img: remiImg,
	},
	{
		name: "Reginald (Reggie)",
		desc: "Midnight Majesty Maran with a dramatic crow and calm leadership.",
		img: reggieImg,
	},
	{
		name: "Randolph (Randy)",
		desc: "Ameraucana rooster with a calm demeanor and striking appearance.",
		img: randolphImg,
	},
];

const DUCKS = [
	{
		name: "Black Swedish",
		desc: "Calm and friendly ducks known for their glossy black feathers and good egg production.",
		img: blackSwedishImg,
	},
	{
		name: "Blue Swedish",
		desc: "A beautiful blue-gray variant of the Swedish breed, known for their gentle nature and reliable laying.",
		img: blueSwedishImg,
	},
	{
		name: "Cayuga",
		desc: "Striking black ducks with iridescent feathers, known for their rich-flavored eggs and calm demeanor.",
		img: cayugaImg,
	},
	{
		name: "Khaki Campbell",
		desc: "Active and prolific layers, these ducks are known for their khaki-colored feathers and high egg production.",
		img: khakiCampbellImg,
	},
	{
		name: "Gold Star Hybrid",
		desc: "A hybrid breed developed for high egg production, these ducks have a friendly disposition and lay large white eggs.",
		img: goldStarHybridImg,
	},
	{
		name: "White Star Hybrid",
		desc: "Another high-producing hybrid, these ducks are known for their white feathers and consistent egg-laying abilities.",
		img: whiteStarHybridImg,
	},
];

const EGG_COLOR_MAP = {
	Brown: "#a0522d",
	"Light Brown": "#deb887",
	"Soft Brown": "#e2b07a",
	Cream: "#fffdd0",
	White: "#f8f8ff",
	Blue: "#8ecae6",
	Green: "#7bb661",
	Variety: "#bdbdbd",
	"Dark Brown": "#6b3e26",
	"Vibrant Green": "#43a047",
	cream: "#fffdd0",
};

function shuffleArray(array) {
	const arr = [...array];
	for (let i = arr.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[arr[i], arr[j]] = [arr[j], arr[i]];
	}
	return arr;
}

export default function EggCartonShuffle() {
	const [carton, setCarton] = useState(Array.from({ length: 6 }, (_, i) => i));
	const [revealed, setRevealed] = useState(null);
	const [score, setScore] = useState(0);
	const [remainingBreeds, setRemainingBreeds] = useState(() =>
		shuffleArray(BREEDS),
	);
	const [remainingRoosters, setRemainingRoosters] = useState(() =>
		shuffleArray(ROOSTERS),
	);
	const [remainingDucks, setRemainingDucks] = useState(() =>
		shuffleArray(DUCKS),
	);

	const [imgLoaded, setImgLoaded] = useState(true);

	const crackEgg = (eggIndex) => {
		// Remove egg from carton
		setCarton(carton.filter((index) => index !== eggIndex));

		// Determine if we reveal a breed, rooster, or duck
		const rand = Math.random();
		let newRevealed = null;
		if (rand < 0.4 && remainingBreeds.length > 0) {
			// Reveal a breed (40% chance)
			const breed = remainingBreeds[0];
			newRevealed = { type: "breed", data: breed };
			setRemainingBreeds(remainingBreeds.slice(1));
			setScore(score + 10);
		} else if (rand < 0.7 && remainingRoosters.length > 0) {
			// Reveal a rooster (30% chance)
			const rooster = remainingRoosters[0];
			newRevealed = { type: "rooster", data: rooster };
			setRemainingRoosters(remainingRoosters.slice(1));
			setScore(score + 5);
		} else if (remainingDucks.length > 0) {
			// Reveal a duck (20% chance)
			const duck = remainingDucks[0];
			newRevealed = { type: "duck", data: duck };
			setRemainingDucks(remainingDucks.slice(1));
			setScore(score + 8);
		} else if (remainingBreeds.length > 0) {
			// Fallback to breed if others exhausted
			const breed = remainingBreeds[0];
			newRevealed = { type: "breed", data: breed };
			setRemainingBreeds(remainingBreeds.slice(1));
			setScore(score + 10);
		} else if (remainingRoosters.length > 0) {
			// Fallback to rooster if breeds exhausted
			const rooster = remainingRoosters[0];
			newRevealed = { type: "rooster", data: rooster };
			setRemainingRoosters(remainingRoosters.slice(1));
			setScore(score + 5);
		}

		setRevealed(newRevealed);
		setImgLoaded(false);
	};

	const handleBackToCarton = () => {
		setRevealed(null);
		setImgLoaded(true);
	};

	const handlePlayAgain = () => {
		setCarton(Array.from({ length: 6 }, (_, i) => i));
		setRevealed(null);
		setScore(0);
		setRemainingBreeds(shuffleArray(BREEDS));
		setRemainingRoosters(shuffleArray(ROOSTERS));
		setRemainingDucks(shuffleArray(DUCKS));
		setImgLoaded(true);
	};

	return (
		<Box mx="auto" p={3}>
			<Paper elevation={3} sx={{ borderRadius: 6, p: { xs: 2, sm: 4 } }}>
				<Typography variant="h4" align="center" fontWeight={700} mb={1}>
					🥚 Egg Carton Shuffle
				</Typography>
				<Typography align="center" color="text.secondary" mb={1}>
					Crack an egg to discover who’s working (or crowing) in the coop!
				</Typography>
				<Typography align="center" color="text.secondary" mb={3}>
					We have over 15 breeds of chickens, 4 roosters, and 6 breeds of ducks
					in our coop. Can you meet them all?
				</Typography>
				{carton.length > 0 && (
					<Box textAlign="center" mb={3}>
						<Chip
							label={`Egg Points: ${score}`}
							color="warning"
							sx={{
								fontWeight: 600,
								fontSize: 18,
								px: 2,
								py: 1,
							}}
						/>
					</Box>
				)}
				<AnimatePresence>
					{!revealed && carton.length > 0 && (
						<motion.div
							initial={{ opacity: 0, y: 30 }}
							animate={{ opacity: 1, y: 0 }}
							exit={{ opacity: 0 }}
						>
							<Box
								display="grid"
								gridTemplateColumns={{
									xs: "1fr 1fr",
									sm: "repeat(3, 1fr)",
								}}
								gap={3}
								justifyItems="center"
								mb={2}
							>
								{carton.map((eggIndex) => (
									<Button
										key={eggIndex}
										onClick={() => crackEgg(eggIndex)}
										sx={{
											width: 90,
											height: 120,
											borderRadius: "50%",
											fontSize: 40,
											background: "#fff",
											boxShadow: 3,
											transition: "0.2s",
											"&:hover": {
												background: "#ffe082",
												transform: "scale(1.08)",
											},
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
										}}
									>
										🥚
									</Button>
								))}
							</Box>
						</motion.div>
					)}
					{carton.length === 0 && !revealed && (
						<motion.div
							initial={{ opacity: 0, y: 30 }}
							animate={{ opacity: 1, y: 0 }}
							exit={{ opacity: 0 }}
						>
							<Box
								display="flex"
								flexDirection="column"
								alignItems="center"
								justifyContent="center"
								mt={4}
							>
								<Typography variant="h4" fontWeight={700} mb={2}>
									🏆 Bird Trophy!
								</Typography>
								<Typography
									variant="h6"
									color="text.secondary"
									mb={2}
								>{`You cracked all the eggs and met the flock!`}</Typography>
								<Box mb={2}>
									<span
										style={{
											fontSize: 80,
											display: "inline-block",
										}}
									>
										🐦
									</span>
								</Box>
								<Chip
									label={`Final Egg Points: ${score}`}
									color="success"
									sx={{
										fontWeight: 600,
										fontSize: 18,
										px: 2,
										py: 1,
									}}
								/>
								<Button
									onClick={handlePlayAgain}
									sx={{
										mt: 3,
										px: 4,
										py: 1.5,
										borderRadius: 8,
										background: "#ffe082",
										fontWeight: 600,
										fontSize: 18,
										"&:hover": {
											background: "#ffd54f",
										},
									}}
								>
									Play Again
								</Button>
							</Box>
						</motion.div>
					)}
					{revealed && (
						<motion.div
							initial={{ opacity: 0, y: 30 }}
							animate={{ opacity: 1, y: 0 }}
							exit={{ opacity: 0 }}
						>
							<Box
								display="flex"
								flexDirection="column"
								alignItems="center"
								justifyContent="center"
								mt={2}
							>
								<Box
									width="100%"
									maxWidth={320}
									height={220}
									display="flex"
									alignItems="center"
									justifyContent="center"
									mb={2}
								>
									{!imgLoaded && <CircularProgress size={48} thickness={4} />}

									<img
										src={revealed.data.img}
										alt={revealed.data.name}
										style={{
											display: imgLoaded ? "block" : "none",
											width: "100%",
											maxWidth: 320,
											height: 220,
											borderRadius: 16,
											objectFit: "cover",
											boxShadow: "0 2px 8px rgba(0,0,0,0.10)",
										}}
										onLoad={() => setImgLoaded(true)}
										onError={(e) => {
											setImgLoaded(true); // hide spinner
										}}
									/>
								</Box>
								<Typography variant="h5" fontWeight={700} mb={1}>{`${
									revealed.type === "breed"
										? "🐔"
										: revealed.type === "rooster"
											? "🐓"
											: "🐣"
								} ${revealed.data.name}`}</Typography>
								<Typography color="text.secondary" mb={1}>
									{revealed.data.desc}
								</Typography>
								{revealed.type === "breed" ? (
									<Box
										display="flex"
										alignItems="center"
										justifyContent="center"
										flexDirection="column"
									>
										<Box mb={1}>
											<Typography fontWeight={600}>
												Egg Color:{" "}
												<Chip
													label={revealed.data.egg}
													size="small"
													sx={{
														backgroundColor:
															EGG_COLOR_MAP[revealed.data.egg] || "#e0e0e0",
														color:
															EGG_COLOR_MAP[revealed.data.egg] === "#fffdd0" ||
															EGG_COLOR_MAP[revealed.data.egg] === "#f8f8ff"
																? "#333"
																: "#fff",
														fontWeight: 700,
														fontSize: 16,
														px: 2,
													}}
												/>
											</Typography>
										</Box>
										<Typography fontWeight={600}>+10 Egg Points!</Typography>
									</Box>
								) : revealed.type === "rooster" ? (
									<Typography fontWeight={600} color="orange">
										+5 Peacekeeping Points!
									</Typography>
								) : revealed.type === "duck" ? (
									<Typography fontWeight={600} color="blue">
										+5 Quacking Points!
									</Typography>
								) : null}
								<Button
									onClick={handleBackToCarton}
									sx={{
										mt: 3,
										px: 4,
										py: 1.5,
										borderRadius: 8,
										background: "#ffe082",
										fontWeight: 600,
										fontSize: 18,
										"&:hover": {
											background: "#ffd54f",
										},
									}}
								>
									Back to Carton
								</Button>
							</Box>
						</motion.div>
					)}
				</AnimatePresence>
			</Paper>
		</Box>
	);
}
